import { Component, Input, ViewEncapsulation } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { TextBoxComponent } from '@progress/kendo-angular-inputs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ADAPTIVE_SETTINGS, AdaptiveService } from '@progress/kendo-angular-utils';
import {
  DatePickerComponent, DatePickerCustomMessagesComponent,
} from '@progress/kendo-angular-dateinputs';
import { Quotation } from 'src/app/shared/models/quotation.model';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-step1',
  standalone: true,
  providers: [
    AdaptiveService,
    {
      provide: ADAPTIVE_SETTINGS,
      useValue: {small: 600, medium: 850}
    }
  ],
  imports: [
    TranslatePipe,
    TextBoxComponent,
    FormsModule,
    ReactiveFormsModule,
    DatePickerComponent,
    DatePickerCustomMessagesComponent,
    NgClass
  ],
  templateUrl: './step1.component.html',
  styleUrl: './step1.component.scss',
  encapsulation: ViewEncapsulation.None
})

export class Step1Component {
  @Input({required: true}) quotation: Quotation;
  @Input() missingNameError: boolean;
  @Input() missingStartDateError: boolean;
  @Input() missingEndDateError: boolean;

  public yesterday: Date;
  public today: Date;
  public format = "dd/MMM/yyyy"


  constructor() {
    this.today = new Date();
    this.yesterday = new Date();
    this.yesterday.setDate(this.today.getDate() - 1);
  }

}
